// src/assets/js/home/heroCarousel.js

export function initHeroCarousel({ root, intervalMs = 6000 } = {}) {
	if (!root) return;

	const viewport = root.querySelector('[data-carousel="viewport"]');
	const prevBtn = root.querySelector('[data-carousel="prev"]');
	const nextBtn = root.querySelector('[data-carousel="next"]');
	const dotBtns = Array.from(root.querySelectorAll('[data-carousel="dot"]'));
	const slides = Array.from(viewport?.querySelectorAll('.hero-slide') || []);

	// 👉 NUEVO: copys dinámicos del overlay
	const copies = Array.from(root.querySelectorAll('.hero-copy'));

	if (!viewport || slides.length === 0) return;

	let index = Math.max(
		0,
		slides.findIndex((s) => s.classList.contains('is-active')),
	);
	if (index < 0) index = 0;

	const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

	const setActive = (newIndex) => {
		const i = ((newIndex % slides.length) + slides.length) % slides.length;
		const slideId = String(i + 1);

		// Slides (figuras)
		slides.forEach((s, n) => {
			const isActive = n === i;
			s.classList.toggle('is-active', isActive);
			s.setAttribute('aria-hidden', String(!isActive));
		});

		// Dots
		dotBtns.forEach((d) => d.classList.toggle('is-active', d.dataset.to === slideId));

		// 👉 NUEVO: Copy dinámico (H2 + P)
		copies.forEach((c) => c.classList.toggle('is-active', c.dataset.slide === slideId));

		index = i;
	};

	const goNext = () => setActive(index + 1);
	const goPrev = () => setActive(index - 1);

	prevBtn?.addEventListener('click', goPrev);
	nextBtn?.addEventListener('click', goNext);

	dotBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const to = Number(btn.dataset.to);
			if (Number.isFinite(to)) setActive(to - 1);
		});
	});

	// Autoplay
	let timer = null;

	const start = () => {
		if (prefersReduced) return;
		stop();
		timer = window.setInterval(goNext, intervalMs);
	};

	const stop = () => {
		if (timer) window.clearInterval(timer);
		timer = null;
	};

	// Pausa al hover/focus
	root.addEventListener('mouseenter', stop);
	root.addEventListener('mouseleave', start);
	root.addEventListener('focusin', stop);
	root.addEventListener('focusout', start);

	setActive(index);
	start();
}
